module.exports = __webpack_public_path__ + "568a8f7f51e11c2d43eca44a0d17263d.svg";